'use client';

import React, { useState } from 'react';
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { useServerInsertedHTML } from 'next/navigation'

if (typeof window !== 'undefined') React.useLayoutEffect = React.useEffect;

const EmotionStyleRegistry = ({ children }: { children: React.ReactNode }) => {
    const [{ cache, flush }] = useState(() => {
        const cache = createCache({ key: 'ant-next' })
        cache.compat = true
        const prevInsert = cache.insert
        let inserted :any = []
        cache.insert = (...args) => {
            const serialized = args[1]
            if (cache.inserted[serialized.name] === undefined) {
                inserted.push(serialized.name)
            }
            return prevInsert(...args)
        }
        const flush = () => {
            const prevInserted = inserted
            inserted = []
            return prevInserted
        }
        return { cache, flush }
    })

    useServerInsertedHTML(() => {
        const names = flush()
        if (names.length === 0) return null
        let styles = ''
        for (const name of names) {
            styles += cache.inserted[name]
        }
        return (
            <style id="emotion" data-emotion={`${cache.key} ${names.join(' ')}`}
                dangerouslySetInnerHTML={{
                    __html: styles,
                }}
            />
        )
    })

    return <CacheProvider value={cache}>{children}</CacheProvider>
}

export default EmotionStyleRegistry;